import React from "react";
import { t } from "../../../components/CustomComponent.js";
import HomeMedia from "./HomeMedia.js";
import ICON from "../icons.js";

/* ============================================================================
 * HomeArticles — บทความอสังหาฯ (4 ใบเรียงแถวเดียว)
 *
 * การ์ดวางภาพไว้ซ้ายและข้อความไว้ขวา ทำให้การ์ดเตี้ยกว่าแบบภาพเต็มด้านบน
 * ส่วนบทความจึงไม่แย่งพื้นที่กับส่วนทรัพย์ซึ่งเป็นเนื้อหาหลักของหน้า
 * เนื้อหาแก้ไขได้จากหลังบ้าน (/ad/home/articles) — API ส่งมาเฉพาะที่เปิดใช้งาน
 * ========================================================================== */
export default function HomeArticles({ data, onOpen, onViewAll }) {
  const items = data?.items || [];

  return (
    <section className="hm-section" id="hm-articles">
      <div className="hm-container">
        <div className="hm-section__head">
          <h2 className="hm-section__title">{data?.section?.title || ""}</h2>
          <button type="button" className="hm-section__link" onClick={onViewAll}>
            {t("view_all")}
            <span className="hm-ico">{ICON.chevron_right}</span>
          </button>
        </div>

        <div className="hm-grid">
          {items.map((item) => (
            <article key={item.uid} className="hm-article" onClick={() => onOpen && onOpen(item)}>
              <div className="hm-article__media">
                {/* มีรูปปกที่อัปโหลดไว้ก็ใช้รูปนั้น ไม่มีก็ใช้ภาพจำลอง */}
                <HomeMedia src={item.src} kind={item.kind} tone={item.tone} ratio={1.15} alt={item.title} />
                <span className="hm-badge hm-badge--light hm-article__tag">{item.tag}</span>
              </div>
              <div className="hm-article__body">
                <h3 className="hm-article__title">{item.title}</h3>
                <span className="hm-article__more">
                  {t("home_article_more")}
                  <span className="hm-ico">{ICON.arrow_right}</span>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
